import { defineStore } from 'pinia';
import homeJson from '@/assets/json/home.json';

export const useCasinoStore = defineStore('casino', {
  state: (): TypeCasinoStore => ({
    rows: [],
    casinoMenuItems: [],
    isLoading: true,
    isLoadingMoreGames: true,
    hasMoreGamesToLoad: false,
    hasError: false,

    popularLiveGames: [],
    popularSlotGames: [],
    isGameModalOpen: false,
    providers: [],

    authModalGames: {
      open: false,
      slug: '',
      title: '',
      subtitle: '',
      image: '',
    },
  }),
  actions: {
    async getFilteredHomeGames(page: number) {
      if (isDev()) {
        console.warn(page);
      }

      try {
        const getGames = async (row: any) => {
          let finalRow: FinalRow | Partial<FinalRow> | null = null;

          switch (row.type) {
            case 'games-api':
              // eslint-disable-next-line
              try {
                const { ApiService } = useApiService();

                const res = await ApiService.get(
                  `/${row.url}&per_page=${row.max_items}`,
                  {
                    server: false,
                    lazy: true,
                  },
                );

                if (Array.isArray(res.data.data) && res.data.data.length > 0) {
                  finalRow = {
                    title: row.title,
                    button: row.button,
                    child: res.data.data,
                    icon: row.icon,
                    sliderType: 'game',
                  };
                }
              } catch (error) {
                throw error;
              }

              break;

            case 'providers-api':
              // eslint-disable-next-line
              try {
                const { ApiService } = useApiService();

                const res = await ApiService.get(
                  `/${row.url}&per_page=${row.max_items}`,
                  {
                    server: false,
                    lazy: true,
                  },
                );

                if (
                  Array.isArray(res.data.providers) &&
                  res.data.providers.length > 0
                ) {
                  finalRow = {
                    title: row.title,
                    button: row.button,
                    icon: row.icon,
                    child: res.data.providers.slice(0, row.max_items) as any[],
                    sliderType: 'provider',
                  };
                }
              } catch (error) {
                throw error;
              }

              break;

            case 'games-fixed':
              if (Array.isArray(row.child) && row.child.length > 0) {
                finalRow = {
                  title: row.title,
                  button: row.button,
                  child: row.child,
                  icon: row.icon,
                  sliderType: 'game',
                };
              }
              break;

            case 'custom-slot':
              finalRow = {
                title: row.title,
                sliderType: row.type,
              };
              break;

            default:
              throw new Error(`Tipo desconhecido: ${row.type}`);
          }

          return finalRow;
        };

        const gamesList = homeJson.HomeGames;

        const requests: Promise<FinalRow | Partial<FinalRow> | null>[] = [];

        for (const row of gamesList) {
          requests.push(getGames(row));
        }

        const finalRows = await Promise.all(requests);

        // Filtrar os resultados não nulos (que têm conteúdo relevante)
        this.rows = finalRows.filter((row) => row !== null) as FinalRow[];
        setTimeout(() => {
          this.isLoading = false;
        }, 10);
      } catch (err) {
        console.error('Erro ao buscar os jogos:', err);
        this.hasError = true;
      }
    },

    async getAllProviders() {
      if (!this.providers.length) {
        const { ApiService } = useApiService();

        const res = await ApiService.get(`/casino-games/filter?&per_page=1`, {
          server: false,
          lazy: true,
        });

        if (Array.isArray(res.data.data) && res.data.data.length > 0) {
          this.providers = res.data.providers;
        }
      }

      return this.providers;
    },

    async fetchCasinoMenuItems() {
      if (!this.rows.length) {
        await this.getFilteredHomeGames(1);
      }
      this.casinoMenuItems = [...this.rows];
    },

    resetAuthModal() {
      this.authModalGames = {
        open: false,
        slug: '',
        title: '',
        subtitle: '',
        image: '',
      };
    },
  },
  getters: {
    allGames: (state): Game[] => {
      return state.rows
        .map((row) => row.child)
        .filter(Boolean)
        .flat();
    },

    allProviders: (state): Game[] => {
      return state.providers || [];
    },

    getCasinoMenuItems: (state): FinalRow[] => {
      return state.rows;
    },
  },
});
